import { useNavigate } from "react-router-dom";

interface CardClassProps {
    data: any;
}

export default function CardClass(props: CardClassProps) {
    const { data } = props;
    const router = useNavigate();
    const handleOpenTooltipClass = () => {

    }

    const handleGetDetailClass = () => {
        router(`/class/${data.id}`);
    }
    return (
        <div onClick={handleGetDetailClass} className="relative rounded-[10px] w-[200px] h-[200px] shadow-default border border-[#e0e0e0] flex flex-col justify-start items-center p-[20px] hover:scale-105 cursor-pointer transition duration-300">
            <p className="rounded-[10px] w-[100px] h-[100px] bg-secondary text-white font-bold flex justify-center items-center p-[4px]">{data.title}</p>
            <p className="h-[10px]"><span className="font-bold">Giáo viên:</span> <span>{data?.teacher?.name ? data?.teacher?.name : ""}</span></p>
            <span onClick={handleOpenTooltipClass} className="absolute bottom-[10px] right-[10px] font-bold text-[20px]">...</span>
        </div>
    )
}